import { useEffect, useState, useCallback } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useGetUser = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getUserProfile = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const profileRes = await customAxios.get('/User/GetUserProfile', {
        headers: authHeader(),
      });

      setUser(profileRes?.data);

      return profileRes?.data;
    } catch (err) {
      console.error('Get User Profile Error:', err);
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getUserProfile();
  }, [getUserProfile]);

  return {
    user,
    loading,
    error,
    refetch: getUserProfile,
  };
};

export default useGetUser;
